import { RsuiteColor } from "@@partner:types:app";

export const PAYMENT_OLD_STATUSES : Record<
string,
{ description: string, color: RsuiteColor }
> = {
  0: {
    description: 'Оплачен',
    color: 'green'
  },
  1: {
    description: 'Ошибка оплаты',
    color: 'red'
  },
  '-1': {
    description: 'Не оплачен',
    color: 'violet'
  }
}